/**
 * 生成uuid接口指纹
 */

/* eslint-disable */
export default function createUuid() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0,
              v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
